import { render, staticRenderFns } from "./CheckoutRecap.html?vue&type=template&id=b3f4e93e&scoped=true&"
import script from "./CheckoutRecap.ts?vue&type=script&lang=ts&"
export * from "./CheckoutRecap.ts?vue&type=script&lang=ts&"
import style0 from "./CheckoutRecap.scss?vue&type=style&index=0&id=b3f4e93e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f4e93e",
  null
  
)

export default component.exports